import { Checkbox, CHECKBOX_SIZE, CHECKBOX_TYPE } from '../../Checkbox'
import { Container } from '../Container'

import { CHECKBOX_LABEL } from './Checkbox.constants'

import * as styles from './Checkboxes.module.css'

function Checkboxes() {
  return (
    <>
      <Container label='Checkbox, default, off, sizes - 16px, 24px'>
        <Checkbox className={styles.rightMargin} size={CHECKBOX_SIZE.small} />
        <Checkbox />
      </Container>
      <Container label='Checkbox, default, off, disabled, sizes - 16px, 24px'>
        <Checkbox
          disabled
          className={styles.rightMargin}
          size={CHECKBOX_SIZE.small}
        />
        <Checkbox disabled />
      </Container>
      <Container label='Checkbox, default, off, error, sizes - 16px, 24px'>
        <Checkbox
          hasError
          className={styles.rightMargin}
          size={CHECKBOX_SIZE.small}
        />
        <Checkbox hasError />
      </Container>
      <Container label='Checkbox, default, on, sizes - 16px, 24px'>
        <Checkbox
          checked
          className={styles.rightMargin}
          size={CHECKBOX_SIZE.small}
        />
        <Checkbox checked />
      </Container>
      <Container label='Checkbox, default, on, disabled, sizes - 16px, 24px'>
        <Checkbox
          checked
          disabled
          className={styles.rightMargin}
          size={CHECKBOX_SIZE.small}
        />
        <Checkbox checked disabled />
      </Container>
      <Container label='Checkbox, default, intermediate, sizes - 16px, 24px'>
        <Checkbox
          selected
          className={styles.rightMargin}
          size={CHECKBOX_SIZE.small}
        />
        <Checkbox selected />
      </Container>
      <Container label='Checkbox, default, intermediate, disabled, sizes - 16px, 24px'>
        <Checkbox
          disabled
          selected
          className={styles.rightMargin}
          size={CHECKBOX_SIZE.small}
        />
        <Checkbox disabled selected />
      </Container>
      <Container label='Checkbox, default, off, with label, sizes - 16px, 24px'>
        <Checkbox
          className={styles.rightMargin}
          label='Label'
          size={CHECKBOX_SIZE.small}
        />
        <Checkbox label='Label' />
      </Container>
      <Container label='Checkbox, default, off, disabled, with label, sizes - 16px, 24px'>
        <Checkbox
          disabled
          className={styles.rightMargin}
          label='Label'
          size={CHECKBOX_SIZE.small}
        />
        <Checkbox disabled label='Label' />
      </Container>
      <Container label='Checkbox, default, off, with label, sizes - 16px, 24px'>
        <Checkbox
          hasError
          className={styles.rightMargin}
          label='Label'
          size={CHECKBOX_SIZE.small}
        />
        <Checkbox hasError label='Label' />
      </Container>
      <Container label='Checkbox, default, on, with label, sizes - 16px, 24px'>
        <Checkbox
          checked
          className={styles.rightMargin}
          label='Label'
          size={CHECKBOX_SIZE.small}
        />
        <Checkbox checked label='Label' />
      </Container>
      <Container label='Checkbox, default, on, disabled, with label, sizes - 16px, 24px'>
        <Checkbox
          checked
          disabled
          className={styles.rightMargin}
          label='Label'
          size={CHECKBOX_SIZE.small}
        />
        <Checkbox checked disabled label='Label' />
      </Container>
      <Container label='Checkbox, default, intermediate, with label, sizes - 16px, 24px'>
        <Checkbox
          selected
          className={styles.rightMargin}
          label='Label'
          size={CHECKBOX_SIZE.small}
        />
        <Checkbox selected label='Label' />
      </Container>
      <Container label='Checkbox, default, intermediate, disabled, with label, sizes - 16px, 24px'>
        <Checkbox
          disabled
          selected
          className={styles.rightMargin}
          label='Label'
          size={CHECKBOX_SIZE.small}
        />
        <Checkbox disabled selected label='Label' />
      </Container>
      <Container label='Checkbox, rounded, off, sizes - 16px, 24px'>
        <Checkbox
          className={styles.rightMargin}
          size={CHECKBOX_SIZE.small}
          type={CHECKBOX_TYPE.rounded}
        />
        <Checkbox type={CHECKBOX_TYPE.rounded} />
      </Container>
      <Container label='Checkbox, rounded, off, disabled, sizes - 16px, 24px'>
        <Checkbox
          disabled
          className={styles.rightMargin}
          size={CHECKBOX_SIZE.small}
          type={CHECKBOX_TYPE.rounded}
        />
        <Checkbox disabled type={CHECKBOX_TYPE.rounded} />
      </Container>
      <Container label='Checkbox, rounded, off, error, sizes - 16px, 24px'>
        <Checkbox
          hasError
          className={styles.rightMargin}
          size={CHECKBOX_SIZE.small}
          type={CHECKBOX_TYPE.rounded}
        />
        <Checkbox hasError type={CHECKBOX_TYPE.rounded} />
      </Container>
      <Container label='Checkbox, rounded, on, sizes - 16px, 24px'>
        <Checkbox
          checked
          className={styles.rightMargin}
          size={CHECKBOX_SIZE.small}
          type={CHECKBOX_TYPE.rounded}
        />
        <Checkbox checked type={CHECKBOX_TYPE.rounded} />
      </Container>
      <Container label='Checkbox, rounded, on, disabled, sizes - 16px, 24px'>
        <Checkbox
          checked
          disabled
          className={styles.rightMargin}
          size={CHECKBOX_SIZE.small}
          type={CHECKBOX_TYPE.rounded}
        />
        <Checkbox checked disabled type={CHECKBOX_TYPE.rounded} />
      </Container>
      <Container label='Checkbox, rounded, intermediate, sizes - 16px, 24px'>
        <Checkbox
          selected
          className={styles.rightMargin}
          size={CHECKBOX_SIZE.small}
          type={CHECKBOX_TYPE.rounded}
        />
        <Checkbox selected type={CHECKBOX_TYPE.rounded} />
      </Container>
      <Container label='Checkbox, rounded, intermediate, disabled, sizes - 16px, 24px'>
        <Checkbox
          disabled
          selected
          className={styles.rightMargin}
          size={CHECKBOX_SIZE.small}
          type={CHECKBOX_TYPE.rounded}
        />
        <Checkbox disabled selected type={CHECKBOX_TYPE.rounded} />
      </Container>
      <Container label='Checkbox, rounded, off, with label, sizes - 16px, 24px'>
        <Checkbox
          className={styles.rightMargin}
          label='Label'
          size={CHECKBOX_SIZE.small}
          type={CHECKBOX_TYPE.rounded}
        />
        <Checkbox label='Label' type={CHECKBOX_TYPE.rounded} />
      </Container>
      <Container label='Checkbox, rounded, off, disabled, with label, sizes - 16px, 24px'>
        <Checkbox
          disabled
          className={styles.rightMargin}
          label='Label'
          size={CHECKBOX_SIZE.small}
          type={CHECKBOX_TYPE.rounded}
        />
        <Checkbox disabled label='Label' type={CHECKBOX_TYPE.rounded} />
      </Container>
      <Container label='Checkbox, rounded, on, with label, sizes - 16px, 24px'>
        <Checkbox
          checked
          className={styles.rightMargin}
          label='Label'
          size={CHECKBOX_SIZE.small}
          type={CHECKBOX_TYPE.rounded}
        />
        <Checkbox checked label='Label' type={CHECKBOX_TYPE.rounded} />
      </Container>
      <Container label='Checkbox, rounded, on, disabled, with label, sizes - 16px, 24px'>
        <Checkbox
          checked
          disabled
          className={styles.rightMargin}
          label='Label'
          size={CHECKBOX_SIZE.small}
          type={CHECKBOX_TYPE.rounded}
        />
        <Checkbox checked disabled label='Label' type={CHECKBOX_TYPE.rounded} />
      </Container>
      <Container label='Checkbox, rounded, intermediate, with label, sizes - 16px, 24px'>
        <Checkbox
          selected
          className={styles.rightMargin}
          label='Label'
          size={CHECKBOX_SIZE.small}
          type={CHECKBOX_TYPE.rounded}
        />
        <Checkbox selected label='Label' type={CHECKBOX_TYPE.rounded} />
      </Container>
      <Container label='Checkbox, rounded, intermediate, disabled, with label, sizes - 16px, 24px'>
        <Checkbox
          disabled
          selected
          className={styles.rightMargin}
          label='Label'
          size={CHECKBOX_SIZE.small}
          type={CHECKBOX_TYPE.rounded}
        />
        <Checkbox
          disabled
          selected
          label='Label'
          type={CHECKBOX_TYPE.rounded}
        />
      </Container>
      <Container label='Checkbox, table, off, size - 16px'>
        <Checkbox
          className={styles.rightMargin}
          size={CHECKBOX_SIZE.small}
          type={CHECKBOX_TYPE.table}
        />
      </Container>
      <Container label='Checkbox, table, off, disabled, size - 16px'>
        <Checkbox
          disabled
          className={styles.rightMargin}
          size={CHECKBOX_SIZE.small}
          type={CHECKBOX_TYPE.table}
        />
      </Container>
      <Container label='Checkbox, table, off, error, size - 16px'>
        <Checkbox
          hasError
          className={styles.rightMargin}
          size={CHECKBOX_SIZE.small}
          type={CHECKBOX_TYPE.table}
        />
      </Container>
      <Container label='Checkbox, table, on, size - 16px'>
        <Checkbox
          checked
          className={styles.rightMargin}
          size={CHECKBOX_SIZE.small}
          type={CHECKBOX_TYPE.table}
        />
      </Container>
      <Container label='Checkbox, table, on, disabled, size - 16px'>
        <Checkbox
          checked
          disabled
          className={styles.rightMargin}
          size={CHECKBOX_SIZE.small}
          type={CHECKBOX_TYPE.table}
        />
      </Container>

      <Container label='Checkbox, table, off, with label, size - 16px'>
        <Checkbox
          className={styles.rightMargin}
          label='Label'
          size={CHECKBOX_SIZE.small}
          type={CHECKBOX_TYPE.table}
        />
      </Container>
      <Container label='Checkbox, table, off, disabled, with label, size - 16px'>
        <Checkbox
          disabled
          className={styles.rightMargin}
          label='Label'
          size={CHECKBOX_SIZE.small}
          type={CHECKBOX_TYPE.table}
        />
      </Container>
      <Container label='Checkbox, table, off, error, with label, size - 16px'>
        <Checkbox
          hasError
          className={styles.rightMargin}
          label='Label'
          size={CHECKBOX_SIZE.small}
          type={CHECKBOX_TYPE.table}
        />
      </Container>
      <Container label='Checkbox, table, on, with label, size - 16px'>
        <Checkbox
          checked
          className={styles.rightMargin}
          label='Label'
          size={CHECKBOX_SIZE.small}
          type={CHECKBOX_TYPE.table}
        />
      </Container>
      <Container label='Checkbox, table, on, disabled, with label, size - 16px'>
        <Checkbox
          checked
          disabled
          className={styles.rightMargin}
          label='Label'
          size={CHECKBOX_SIZE.small}
          type={CHECKBOX_TYPE.table}
        />
      </Container>
      <Container label='Checkbox, action, on, with long label, size - 16px'>
        <Checkbox
          checked
          className={styles.rightMargin}
          label={CHECKBOX_LABEL}
          size={CHECKBOX_SIZE.small}
          type={CHECKBOX_TYPE.action}
        />
      </Container>
      <Container label='Checkbox, with text btn, size - 16px'>
        <Checkbox
          checked
          buttonProps={{ text: 'Text button' }}
          className={styles.rightMargin}
          label='Label'
          size={CHECKBOX_SIZE.small}
        />
      </Container>
      <Container label='Checkbox, action, on, with long label and text btn, size - 16px'>
        <Checkbox
          checked
          buttonProps={{ text: 'Text button' }}
          className={styles.rightMargin}
          label={CHECKBOX_LABEL}
          size={CHECKBOX_SIZE.small}
          type={CHECKBOX_TYPE.action}
        />
      </Container>
    </>
  )
}

export default Checkboxes
